import { render, staticRenderFns } from "./KeyValueCell.vue?vue&type=template&id=12ef55fc&scoped=true&"
import script from "./KeyValueCell.vue?vue&type=script&lang=js&"
export * from "./KeyValueCell.vue?vue&type=script&lang=js&"
import style0 from "./KeyValueCell.vue?vue&type=style&index=0&id=12ef55fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ef55fc",
  null
  
)

export default component.exports